import {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
} from '@ionic/react';
import React from 'react';

type PageProps = {
    title: string;
    ionButtons?: React.ReactNode;
    children: React.ReactNode;
    withPadding?: boolean;
};
const Page: React.FunctionComponent<PageProps> = ({
    title,
    ionButtons,
    children,
    withPadding = false,
}) => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{title}</IonTitle>
                    {ionButtons}
                </IonToolbar>
            </IonHeader>
            <IonContent
                className={withPadding ? 'ion-padding' : ''}
                fullscreen
            >
                {children}
            </IonContent>
        </IonPage>
    );
};

export default Page;
